// extracted by mini-css-extract-plugin
export default {"lds-roller":"Styles_lds-roller__AELzX"};